/**
 * Helper for the venue-setup back-arrow behaviour.
 *
 * The 4 sub-pages the setup-mode home links to (Photos, Vibe/Card,
 * Operating Hours, Social Media) are also reachable from
 * `/venue/settings/*` for approved venues. In both cases we want the
 * back arrow to return the owner to the surface they came from —
 * `/venue/setup-mode` for owners still finishing setup, `/venue/settings`
 * otherwise.
 *
 * `location.state?.from` normally covers this, but Capacitor cold-launches
 * and history-replace redirects can drop `state`, which then falls back
 * to the `routeParents.js` map (always `/venue/settings`) and drops the
 * setup-mode owner on the wrong page. Persisting a tiny sessionStorage
 * flag on the way in makes the return leg bulletproof.
 */
const KEY = 'venue_setup_return_to';

export function setVenueSetupReturnPath(path) {
  try {
    if (path) sessionStorage.setItem(KEY, path);
    else sessionStorage.removeItem(KEY);
  } catch { /* sessionStorage unavailable — noop */ }
}

export function getVenueSetupReturnPath() {
  try {
    return sessionStorage.getItem(KEY) || '';
  } catch {
    return '';
  }
}

export function clearVenueSetupReturnPath() {
  try {
    sessionStorage.removeItem(KEY);
  } catch { /* noop */ }
}
